var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 0.843994C25.09 0.843994 0.84375 25.0903 0.84375 55.0001C0.84375 84.9099 25.09 109.156 54.9998 109.156C84.9097 109.156 109.156 84.9099 109.156 55.0001C109.156 25.0903 84.9097 0.843994 54.9998 0.843994ZM82.0911 70.6632C82.0911 72.8295 80.3341 74.5865 78.1678 74.5865H31.8319C29.6656 74.5865 27.9086 72.8295 27.9086 70.6632V48.6121L54.9998 57.8162L82.0911 48.6133V70.6632ZM82.0911 42.981L54.9998 52.184L27.9086 42.981V39.3369C27.9086 37.1707 29.6656 35.4136 31.8319 35.4136H78.1666C80.3329 35.4136 82.0899 37.1707 82.0899 39.3369V42.981H82.0911Z",
    fill: "#103C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/email-box.db451e315b251e544e450e2a382f8821.svg";
export { ForwardRef as ReactComponent };